import React, { memo, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getFeeTypeByCalculationTypeAction } from 'store/system/actions/feeTypes.actions';

import usePendingChangesAuthorsControls from '../../../hooks/usePendingChangesAuthorsControls';
import PendingChangesSaveSummary from '../PendingChangesSaveSummary';

// Reads the changes from the store while the dialog is open, so a dialog opened before the loan's change
// history arrived fills in once it does instead of showing an empty summary. A fee is named from the fee types, and
// most loan tabs do not load them (a deleted fee type needs includeDeleted), so the summary loads them itself or its
// fee lines are left out.
const PendingChangesLiveSaveSummary = ({ authorKeys, isOwnChangesScope }) => {
  const dispatch = useDispatch();

  const { getSaveSummary } = usePendingChangesAuthorsControls();

  const summary = useMemo(() => getSaveSummary(authorKeys), [getSaveSummary, authorKeys]);

  useEffectSafeStrictMode(() => {
    dispatch(getFeeTypeByCalculationTypeAction({ calculationType: null, includeDeleted: true }));
  }, [dispatch]);

  return <PendingChangesSaveSummary isOwnChangesScope={isOwnChangesScope} summary={summary} />;
};

PendingChangesLiveSaveSummary.propTypes = {
  authorKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  isOwnChangesScope: PropTypes.bool.isRequired,
};

export default memo(PendingChangesLiveSaveSummary);
